import axios from "axios";
import { captureeventbaseanalytics } from "../../../Libraries/Media";
import {
  React,
  useEffect,
  useCallback,
  TabView,
  TabPanel,
  useGetMediaMutation,
  FileUploader,
  VideoThumbnail,
  Radio,
  Empty,
  memo,
  toast,
  useState,
  Box,
  GetCookie,
} from "../../../Libraries/Post/EditPost/Child/EditPostMiddleForm/EditChooseMedia/index";
import { BASEURL, CONTENT_BASEURL, MAX_UPLOAD_FILE_SIZE } from "../../../Utils/Constants/constants";
import LoadingSpinner from "../../Loaders/NETWORKCALLLOADER/LoadingSpinner";
import "./editchoosemedia.css";
const fileTypes = ["JPG", "PNG", "mp4"];

const EditChooseMedia = (props) => {
  const [getMedia, { isLoading: loadingwhilemediagetting }] =
    useGetMediaMutation();
  const [data, setdata] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalprogress, settotalprogress] = useState(0);
  const [isloading, setisloading] = useState(false);

  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    settotalprogress(percentCompleted);
    if (percentCompleted === 100) {
      setTimeout(() => {
        settotalprogress(0);
      }, 400);
    }
  };

  const handleChange = async (file) => {
    if (file) {
      if (file.size >= MAX_UPLOAD_FILE_SIZE) {
        toast.info("Max file upload size is 900Mb");
      } else {
        setisloading(true);
        const mediadata = new FormData();
        mediadata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        mediadata.append("security_token", await GetCookie("es_token"));
        mediadata.append("upload_type", "File");
        mediadata.append("myFile", file);
        try {
          setisloading(true);
          const returned = await axios.post(
            CONTENT_BASEURL + "boostboard-content/addMedia.php",
            mediadata,
            { onUploadProgress }
          );
          if (
            returned.data.status === "true" &&
            returned.data.connection === "true" &&
            returned.data.message === "File uploaded successfully"
          ) {
            setisloading(false);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
            toast.success(returned.data.message);
            getAllMediaFunc();
            setActiveIndex(0);
          } else {
            setisloading(false);
            toast.error(returned.data.message);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
          }
        } catch (error) {
          console.log(error);
          setisloading(false);
          toast.error(error.status);
          captureeventbaseanalytics(
            "Media",
            "postMedia.php upload_type:File RESPONSE",
            error.status
          );
        }
      }
    } else {
      toast.error("No File Selected");
    }
  };

  const handleSelectedFile = useCallback(
    (e, file, type, media_id, ext) => {
      props?.setfinalfile({
        txt_media_streaming_link: file,
        txt_media_file_type: type,
        ser_media_id: media_id,
        txt_media_file_extenstion: ext,
      });
    },
    [props]
  );

  const getAllMediaFunc = useCallback(async () => {
    try {
      const Mediadata = new FormData();
      Mediadata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      Mediadata.append("security_token", await GetCookie("es_token"));
      const res = await getMedia(Mediadata).unwrap();
      if (
        res.message === "Media available" &&
        res.status === "true" &&
        res.connection === "true"
      ) {
        setdata(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  }, [getMedia]);

  useEffect(() => {
    getAllMediaFunc();
  }, [getMedia, getAllMediaFunc]);

  return (
    <>
      {isloading || loadingwhilemediagetting ? (
        <LoadingSpinner totalprogress={totalprogress} />
      ) : null}
      <div className="tabview-demo">
        <TabView
          style={{ borderRadius: "10px" }}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Choose From Media Library">
            <Box>
              <div className="grid mb-3">
                {data?.length > 0 ? (
                  data?.map((image, index) => (
                    <div className="md:col-3 lg:col-3 g-1" key={index}>
                      <div className="surface-0 shadow-2 carddesign outerdesign">
                        <div className="flex justify-content-end p-2">
                          {/* <div>
                            <span className="block text-500 font-medium text-black">
                              {image.txt_media_full_name}
                            </span>
                          </div> */}
                          <div
                            className="flex align-items-center justify-content-center border-round"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          >
                            <Radio
                              checked={
                                props?.finalfile?.txt_media_streaming_link ===
                                image.txt_media_streaming_link
                              }
                              name="radio-buttons"
                              value={image.txt_media_full_name}
                              onChange={(e) =>
                                handleSelectedFile(
                                  e,
                                  image.txt_media_streaming_link,
                                  image.txt_media_file_type,
                                  image.ser_media_id,
                                  image.txt_media_file_extenstion
                                )
                              }
                              inputProps={{ "aria-label": "A" }}
                            />
                          </div>
                        </div>
                        {image.txt_media_file_type === "Image" ? (
                          <img
                            src={
                              image.txt_media_streaming_link !== null
                                ? image.txt_media_streaming_link
                                : VideoThumbnail
                            }
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        ) : image.txt_media_file_type === "Video" ? (
                          <img
                            src={
                              image.base64_media_thumbnail !== null
                                ? image.base64_media_thumbnail
                                : VideoThumbnail
                            }
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        ) : (
                          <img
                            src={VideoThumbnail}
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <Empty />
                )}
              </div>
            </Box>
          </TabPanel>
          <TabPanel header="Choose From Your Computer">
            <div className="choosemediaineditpost">
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
              />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </>
  );
};

export default memo(EditChooseMedia);
